import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Agency_BrachTreeViewProperties } from '../Models/Agency_BrachTreeViewProperties';

@Injectable({
  providedIn: 'root'
})
export class Agency_BrachTreeViewService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  GetAgency_BranchTreeView(param): Observable<Agency_BrachTreeViewProperties[]> {
    return this.http.get<Agency_BrachTreeViewProperties[]>(this.baseUrl + '/Agency_BranchTreeView/GetAgency_BranchTreeView/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  DeleteAgency_Branch(param, isAgency): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/AgencyMaster/DeleteAgency_Branch/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  InActiveAgency_Branch(param, isAgency): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/AgencyMaster/InActiveAgencyBranch/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
}
